module.exports = __webpack_public_path__ + "static/10-d0a45d9ba5cf053ab87f35e94a392727.jpg";